<template>
    <div>
        <loader v-if="loading"></loader>
        <el-form v-else ref="addBusCompany"
                 label-position="left"
                 :model="bus_line" :rules="formRules"
                 class="newEventFormStyle">
            <el-form-item label="Line name" prop="name">
                <el-input v-model="bus_line.name"></el-input>
            </el-form-item>
            <el-form-item label="Time" prop="time">
                <el-input v-model="bus_line.time"></el-input>
            </el-form-item>
            <el-form-item label="Price" prop="price">
                <el-input type="number" style="width: 100%" v-model="bus_line.price">
                    <template slot="append">den</template>
                </el-input>
            </el-form-item>
            <el-form-item label="Distance in km" prop="distance">
                <el-input type="number" style="width: 100%" v-model="bus_line.distance">
                    <template slot="append">km</template>
                </el-input>

            </el-form-item>
            <el-button type="primary" style="width: 100%"  @click="addLine">Add Line</el-button>
        </el-form>
    </div>
</template>

<script>

    import BusService from '@/common/services/bus.service'
    import Loader from "../../common/components/loader";
    import {mapState} from "vuex";

    export default {
        name: 'AddBusLine',
        components: {Loader},
        data() {
            return {
                bus_line: {
                    name: '',
                    userEmail: '',
                    time: '',
                    price: '',
                    distance: ''
                },
                formRules: {
                    name: {
                        required: true,
                        trigger: 'change',
                    },
                },
            }
        },

        computed:{
          ...mapState({
              user_email:state => state.user.user_email
          })
        },
        methods: {
            addLine() {
                this.loading = true;
                this.bus_line.userEmail = this.user_email;
                this.bus_line.distance = this.bus_line.distance.toString() + ' km';
                BusService.addBusLine(this.bus_line).then(() => {
                    this.$notify.success({
                        title: `Bus`,
                        message: 'Successfully added bus line'
                    });
                    this.$emit('close')
                }).catch(error => {
                    this.$notify.error({
                        title: `Failed to add bus line`,
                        message: error.response.data.message
                    });
                }).finally(() => this.loading = false)
            }
        }
    }
</script>
